import { Row, Space } from 'antd';
import { useContext, useMemo } from 'react';

import { ClientFiltersContext } from '@app/providers';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters/ClientFilterTag';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

/* eslint-disable @typescript-eslint/no-explicit-any */

const MIN_AGE = 'MinAge';
const MAX_AGE = 'MaxAge';

export const RangeLabel: NClientsList.RangeLabel = ({
  className,
  label,
  filtersArea,
  includedFiltersIndex,
  minFilterKey,
  maxFilterKey,
}) => {
  const {
    filters,
    serverFilters,
    memoizedServerFilters,
    setFilters,
    setServerFilters,
  } = useContext(ClientFiltersContext);

  const minValue = useMemo(
    () =>
      (
        memoizedServerFilters[filtersArea]?.[includedFiltersIndex]
          ?.Values?.[0] as any
      )?.[minFilterKey],
    [includedFiltersIndex, minFilterKey, filtersArea, memoizedServerFilters]
  );
  const maxValue = useMemo(
    () =>
      (
        memoizedServerFilters[filtersArea]?.[includedFiltersIndex]
          ?.Values?.[0] as any
      )?.[maxFilterKey],
    [includedFiltersIndex, maxFilterKey, filtersArea, memoizedServerFilters]
  );

  const getTagCondition = (
    activeKey: typeof MIN_AGE | typeof MAX_AGE,
    borderKey: string,
    borderValue: number
  ) => {
    if (borderKey === activeKey) {
      return borderValue || borderValue === 0;
    }

    return borderValue;
  };

  return (
    <Space className={className + includedFiltersIndex} direction="vertical">
      <span>{label}</span>
      {(getTagCondition(MIN_AGE, minFilterKey, minValue) ||
        getTagCondition(MAX_AGE, maxFilterKey, maxValue)) && (
        <Row>
          {getTagCondition(MIN_AGE, minFilterKey, minValue) && (
            <ClientFilterTag
              filters={filters}
              serverFilters={serverFilters}
              filtersArea={filtersArea}
              filterGroupIndex={includedFiltersIndex}
              setFilters={setFilters}
              setServerFilters={setServerFilters}
              valueKey={
                // TODO: переписать в рамках task/3444 этот тип на уровне всего сервиса "Клиенты"
                minFilterKey as keyof NClientsList.VisitsFilterUnitValue['MinServicesCost']
              }
            >
              {`от ${minValue}`}
            </ClientFilterTag>
          )}
          {getTagCondition(MAX_AGE, maxFilterKey, maxValue) && (
            <ClientFilterTag
              filters={filters}
              serverFilters={serverFilters}
              filtersArea={filtersArea}
              filterGroupIndex={includedFiltersIndex}
              setFilters={setFilters}
              setServerFilters={setServerFilters}
              valueKey={
                // TODO: переписать в рамках task/3444 этот тип на уровне всего сервиса "Клиенты"
                maxFilterKey as keyof NClientsList.VisitsFilterUnitValue['MaxServicesCost']
              }
            >{`до ${maxValue}`}</ClientFilterTag>
          )}
        </Row>
      )}
    </Space>
  );
};
